/** First second from a sequence time range (e.g. "4-10" → 4). */
export function parseSequenceStartSeconds(timeRange: string): number | null {
  const match = timeRange.trim().match(/^(\d+)/);
  if (!match) return null;
  const seconds = Number(match[1]);
  return Number.isFinite(seconds) ? seconds : null;
}
